module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.3a73010.woff2";